// removed by extract-text-webpack-plugin
module.exports = {"bagLinks":"OWGtwg_","buttonContainer":"_2VB_6B_"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/BagLinks/index.css
// module id = ./template/components/MiniBag/Footer/BagLinks/index.css
// module chunks = client.sitechrome